import BaseNode, { BaseNodeProps } from "./BaseNode";
import { nodesConfig } from "./nodes-config";

// Existing EvaluatorNode doesn't need change as it matches 'Decision/Evaluator'
export const EvaluatorNode: React.FC<BaseNodeProps> = (props) => {
  return (
    <BaseNode
      {...nodesConfig.evaluatorNode}
      {...props}
      nodeConfig={props.data?.nodeConfig}
    />
  )
}

// Existing TransformerNode maps to 'Transformer/Custom'
export const TransformerNode: React.FC<BaseNodeProps> = (props) => {
  return (
    <BaseNode
      {...nodesConfig.transformerNode}
      {...props}
      nodeConfig={props.data?.nodeConfig}
    />
  )
}

// Renaming Data Enricher - API node
export const DataEnricherApiNode: React.FC<BaseNodeProps> = (props) => {
  return (
    <BaseNode
      {...nodesConfig.dataEnricherApiNode}
      {...props}
      nodeConfig={props.data?.nodeConfig}
    />
  )
}

// Renaming Data Enricher - DB Lookup node
export const DataEnricherDbLookupNode: React.FC<BaseNodeProps> = (props) => {
  return (
    <BaseNode
      {...nodesConfig.dataEnricherDbLookupNode}
      {...props}
      nodeConfig={props.data?.nodeConfig}
    />
  )
}

// Renaming Data Enricher - Graph Lookup node
export const DataEnricherGraphLookupNode: React.FC<BaseNodeProps> = (props) => {
  return (
    <BaseNode
      {...nodesConfig.dataEnricherGraphLookupNode}
      {...props}
      nodeConfig={props.data?.nodeConfig}
    />
  )
}

// Renaming Data Enricher - ML Prediction node
export const DataEnricherMlPredictionNode: React.FC<BaseNodeProps> = (props) => {
  return (
    <BaseNode
      {...nodesConfig.dataEnricherMlPredictionNode}
      {...props}
      nodeConfig={props.data?.nodeConfig}
    />
  )
}

// Existing WebhookNode matches 'Push - Webhook'
export const PushWebhookNode: React.FC<BaseNodeProps> = (props) => {
  return (
    <BaseNode
      {...nodesConfig.pushWebhookNode}
      {...props}
      nodeConfig={props.data?.nodeConfig}
    />
  )
}

// Renaming Push - DB node
export const PushDbNode: React.FC<BaseNodeProps> = (props) => {
  return (
    <BaseNode
      {...nodesConfig.pushDbNode}
      {...props}
      nodeConfig={props.data?.nodeConfig}
    />
  )
}

// Renaming Push - Queue node
export const PushQueueNode: React.FC<BaseNodeProps> = (props) => {
  return (
    <BaseNode
      {...nodesConfig.pushQueueNode}
      {...props}
      nodeConfig={props.data?.nodeConfig}
    />
  )
}

// Renaming Notification - Email node
export const NotificationEmailNode: React.FC<BaseNodeProps> = (props) => {
  return (
    <BaseNode
      {...nodesConfig.notificationEmailNode}
      {...props}
      nodeConfig={props.data?.nodeConfig}
    />
  )
}

// Renaming Notification - Slack to NotificationSlackNode
export const NotificationSlackNode: React.FC<BaseNodeProps> = (props) => {
  return (
    <BaseNode
      {...nodesConfig.notificationSlackNode}
      {...props}
      nodeConfig={props.data?.nodeConfig}
    />
  )
}
